import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as createCalendarExportLink from "./createCalendarExportLink";
import * as retrieveCalendarExportLinks from "./retrieveCalendarExportLinks";

const initialState: State = {
  createCalendarExportLink: createCalendarExportLink.initialState,
  retrieveCalendarExportLinks: retrieveCalendarExportLinks.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createCalendarExportLink: createCalendarExportLink.reduceState,
  retrieveCalendarExportLinks: retrieveCalendarExportLinks.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createCalendarExportLink.createSelector(
      () => getState().createCalendarExportLink,
    ),
    ...retrieveCalendarExportLinks.createSelector(
      () => getState().retrieveCalendarExportLinks,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
